export default "__VITE_ASSET__C2EUP9z6__"